import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  id: "legend-list",
  class: "legend-list"
}
const _hoisted_2 = ["value"]
const _hoisted_3 = ["value"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・一般国道 ", -1)
const _hoisted_6 = {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", null, "0～1,499(台)", -1)
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("th", null, "1,500～2,999(台)", -1)
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", null, "3,000～4,499(台)", -1)
const _hoisted_13 = ["src"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("th", null, "4,500～5,999(台)", -1)
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("th", null, "6,000～7,499(台)", -1)
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("th", null, "7,500(台)以上", -1)
const _hoisted_19 = ["src"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("th", null, "欠測", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・高速道路（国管理） ", -1)
const _hoisted_22 = {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}
const _hoisted_23 = ["src"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("th", null, "0～999(台)", -1)
const _hoisted_25 = ["src"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("th", null, "1,000～1,999(台)", -1)
const _hoisted_27 = ["src"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("th", null, "2,000～2,999(台)", -1)
const _hoisted_29 = ["src"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("th", null, "3,000～3,999(台)", -1)
const _hoisted_31 = ["src"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("th", null, "4,000～4,999(台)", -1)
const _hoisted_33 = ["src"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("th", null, "5,000(台)以上", -1)
const _hoisted_35 = ["src"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("th", null, "欠測", -1)
const _hoisted_37 = { key: 1 }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・一般国道 ", -1)
const _hoisted_39 = {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}
const _hoisted_40 = ["src"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("th", null, "0～999(台)", -1)
const _hoisted_42 = ["src"]
const _hoisted_43 = /*#__PURE__*/_createElementVNode("th", null, "1,000～1,999(台)", -1)
const _hoisted_44 = ["src"]
const _hoisted_45 = /*#__PURE__*/_createElementVNode("th", null, "2,000～2,999(台)", -1)
const _hoisted_46 = ["src"]
const _hoisted_47 = /*#__PURE__*/_createElementVNode("th", null, "3,000～3,999(台)", -1)
const _hoisted_48 = ["src"]
const _hoisted_49 = /*#__PURE__*/_createElementVNode("th", null, "4,000～4,999(台)", -1)
const _hoisted_50 = ["src"]
const _hoisted_51 = /*#__PURE__*/_createElementVNode("th", null, "5,000(台)以上", -1)
const _hoisted_52 = ["src"]
const _hoisted_53 = /*#__PURE__*/_createElementVNode("th", null, "欠測", -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・高速道路（国管理） ", -1)
const _hoisted_55 = {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}
const _hoisted_56 = ["src"]
const _hoisted_57 = /*#__PURE__*/_createElementVNode("th", null, "0～599(台)", -1)
const _hoisted_58 = ["src"]
const _hoisted_59 = /*#__PURE__*/_createElementVNode("th", null, "600～1,199(台)", -1)
const _hoisted_60 = ["src"]
const _hoisted_61 = /*#__PURE__*/_createElementVNode("th", null, "1,200～1,799(台)", -1)
const _hoisted_62 = ["src"]
const _hoisted_63 = /*#__PURE__*/_createElementVNode("th", null, "1,800～2,399(台)", -1)
const _hoisted_64 = ["src"]
const _hoisted_65 = /*#__PURE__*/_createElementVNode("th", null, "2,400～2,999(台)", -1)
const _hoisted_66 = ["src"]
const _hoisted_67 = /*#__PURE__*/_createElementVNode("th", null, "3,000(台)以上", -1)
const _hoisted_68 = ["src"]
const _hoisted_69 = /*#__PURE__*/_createElementVNode("th", null, "欠測", -1)
const _hoisted_70 = { key: 2 }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・一般国道 ", -1)
const _hoisted_72 = {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}
const _hoisted_73 = ["src"]
const _hoisted_74 = /*#__PURE__*/_createElementVNode("th", null, "0～149(台)", -1)
const _hoisted_75 = ["src"]
const _hoisted_76 = /*#__PURE__*/_createElementVNode("th", null, "150～299(台)", -1)
const _hoisted_77 = ["src"]
const _hoisted_78 = /*#__PURE__*/_createElementVNode("th", null, "300～449(台)", -1)
const _hoisted_79 = ["src"]
const _hoisted_80 = /*#__PURE__*/_createElementVNode("th", null, "450～599(台)", -1)
const _hoisted_81 = ["src"]
const _hoisted_82 = /*#__PURE__*/_createElementVNode("th", null, "600～749(台)", -1)
const _hoisted_83 = ["src"]
const _hoisted_84 = /*#__PURE__*/_createElementVNode("th", null, "750(台)以上", -1)
const _hoisted_85 = ["src"]
const _hoisted_86 = /*#__PURE__*/_createElementVNode("th", null, "欠測", -1)
const _hoisted_87 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・高速道路（国管理） ", -1)
const _hoisted_88 = {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}
const _hoisted_89 = ["src"]
const _hoisted_90 = /*#__PURE__*/_createElementVNode("th", null, "0～79(台)", -1)
const _hoisted_91 = ["src"]
const _hoisted_92 = /*#__PURE__*/_createElementVNode("th", null, "80～159(台)", -1)
const _hoisted_93 = ["src"]
const _hoisted_94 = /*#__PURE__*/_createElementVNode("th", null, "160～239(台)", -1)
const _hoisted_95 = ["src"]
const _hoisted_96 = /*#__PURE__*/_createElementVNode("th", null, "240～319(台)", -1)
const _hoisted_97 = ["src"]
const _hoisted_98 = /*#__PURE__*/_createElementVNode("th", null, "320～399(台)", -1)
const _hoisted_99 = ["src"]
const _hoisted_100 = /*#__PURE__*/_createElementVNode("th", null, "400(台)以上", -1)
const _hoisted_101 = ["src"]
const _hoisted_102 = /*#__PURE__*/_createElementVNode("th", null, "欠測", -1)
const _hoisted_103 = { key: 3 }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・一般国道 ", -1)
const _hoisted_105 = {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}
const _hoisted_106 = ["src"]
const _hoisted_107 = /*#__PURE__*/_createElementVNode("th", null, "0～99(台)", -1)
const _hoisted_108 = ["src"]
const _hoisted_109 = /*#__PURE__*/_createElementVNode("th", null, "100～199(台)", -1)
const _hoisted_110 = ["src"]
const _hoisted_111 = /*#__PURE__*/_createElementVNode("th", null, "200～299(台)", -1)
const _hoisted_112 = ["src"]
const _hoisted_113 = /*#__PURE__*/_createElementVNode("th", null, "300～399(台)", -1)
const _hoisted_114 = ["src"]
const _hoisted_115 = /*#__PURE__*/_createElementVNode("th", null, "400～499(台)", -1)
const _hoisted_116 = ["src"]
const _hoisted_117 = /*#__PURE__*/_createElementVNode("th", null, "500(台)以上", -1)
const _hoisted_118 = ["src"]
const _hoisted_119 = /*#__PURE__*/_createElementVNode("th", null, "欠測", -1)
const _hoisted_120 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・高速道路（国管理） ", -1)
const _hoisted_121 = {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}
const _hoisted_122 = ["src"]
const _hoisted_123 = /*#__PURE__*/_createElementVNode("th", null, "0～9(台)", -1)
const _hoisted_124 = ["src"]
const _hoisted_125 = /*#__PURE__*/_createElementVNode("th", null, "10～19(台)", -1)
const _hoisted_126 = ["src"]
const _hoisted_127 = /*#__PURE__*/_createElementVNode("th", null, "20～39(台)", -1)
const _hoisted_128 = ["src"]
const _hoisted_129 = /*#__PURE__*/_createElementVNode("th", null, "40～59(台)", -1)
const _hoisted_130 = ["src"]
const _hoisted_131 = /*#__PURE__*/_createElementVNode("th", null, "60～99(台)", -1)
const _hoisted_132 = ["src"]
const _hoisted_133 = /*#__PURE__*/_createElementVNode("th", null, "100(台)以上", -1)
const _hoisted_134 = ["src"]
const _hoisted_135 = /*#__PURE__*/_createElementVNode("th", null, "欠測", -1)
const _hoisted_136 = { key: 4 }
const _hoisted_137 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・一般国道 ", -1)
const _hoisted_138 = {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}
const _hoisted_139 = ["src"]
const _hoisted_140 = /*#__PURE__*/_createElementVNode("th", null, "0～1,499(台)", -1)
const _hoisted_141 = ["src"]
const _hoisted_142 = /*#__PURE__*/_createElementVNode("th", null, "1,500～2,999(台)", -1)
const _hoisted_143 = ["src"]
const _hoisted_144 = /*#__PURE__*/_createElementVNode("th", null, "3,000～4,499(台)", -1)
const _hoisted_145 = ["src"]
const _hoisted_146 = /*#__PURE__*/_createElementVNode("th", null, "4,500～5,999(台)", -1)
const _hoisted_147 = ["src"]
const _hoisted_148 = /*#__PURE__*/_createElementVNode("th", null, "6,000～7,499(台)", -1)
const _hoisted_149 = ["src"]
const _hoisted_150 = /*#__PURE__*/_createElementVNode("th", null, "7,500(台)以上", -1)
const _hoisted_151 = ["src"]
const _hoisted_152 = /*#__PURE__*/_createElementVNode("th", null, "欠測", -1)
const _hoisted_153 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・高速道路（国管理） ", -1)
const _hoisted_154 = {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}
const _hoisted_155 = ["src"]
const _hoisted_156 = /*#__PURE__*/_createElementVNode("th", null, "0～999(台)", -1)
const _hoisted_157 = ["src"]
const _hoisted_158 = /*#__PURE__*/_createElementVNode("th", null, "1,000～1,999(台)", -1)
const _hoisted_159 = ["src"]
const _hoisted_160 = /*#__PURE__*/_createElementVNode("th", null, "2,000～2,999(台)", -1)
const _hoisted_161 = ["src"]
const _hoisted_162 = /*#__PURE__*/_createElementVNode("th", null, "3,000～3,999(台)", -1)
const _hoisted_163 = ["src"]
const _hoisted_164 = /*#__PURE__*/_createElementVNode("th", null, "4,000～4,999(台)", -1)
const _hoisted_165 = ["src"]
const _hoisted_166 = /*#__PURE__*/_createElementVNode("th", null, "5,000(台)以上", -1)
const _hoisted_167 = ["src"]
const _hoisted_168 = /*#__PURE__*/_createElementVNode("th", null, "欠測", -1)
const _hoisted_169 = { key: 5 }
const _hoisted_170 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・一般国道 ", -1)
const _hoisted_171 = {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}
const _hoisted_172 = ["src"]
const _hoisted_173 = /*#__PURE__*/_createElementVNode("th", null, "0～999(台)", -1)
const _hoisted_174 = ["src"]
const _hoisted_175 = /*#__PURE__*/_createElementVNode("th", null, "1,000～1,999(台)", -1)
const _hoisted_176 = ["src"]
const _hoisted_177 = /*#__PURE__*/_createElementVNode("th", null, "2,000～2,999(台)", -1)
const _hoisted_178 = ["src"]
const _hoisted_179 = /*#__PURE__*/_createElementVNode("th", null, "3,000～3,999(台)", -1)
const _hoisted_180 = ["src"]
const _hoisted_181 = /*#__PURE__*/_createElementVNode("th", null, "4,000～4,999(台)", -1)
const _hoisted_182 = ["src"]
const _hoisted_183 = /*#__PURE__*/_createElementVNode("th", null, "5,000(台)以上", -1)
const _hoisted_184 = ["src"]
const _hoisted_185 = /*#__PURE__*/_createElementVNode("th", null, "欠測", -1)
const _hoisted_186 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・高速道路（国管理） ", -1)
const _hoisted_187 = {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}
const _hoisted_188 = ["src"]
const _hoisted_189 = /*#__PURE__*/_createElementVNode("th", null, "0～599(台)", -1)
const _hoisted_190 = ["src"]
const _hoisted_191 = /*#__PURE__*/_createElementVNode("th", null, "600～1,199(台)", -1)
const _hoisted_192 = ["src"]
const _hoisted_193 = /*#__PURE__*/_createElementVNode("th", null, "1,200～1,799(台)", -1)
const _hoisted_194 = ["src"]
const _hoisted_195 = /*#__PURE__*/_createElementVNode("th", null, "1,800～2,399(台)", -1)
const _hoisted_196 = ["src"]
const _hoisted_197 = /*#__PURE__*/_createElementVNode("th", null, "2,400～2,999(台)", -1)
const _hoisted_198 = ["src"]
const _hoisted_199 = /*#__PURE__*/_createElementVNode("th", null, "3,000(台)以上", -1)
const _hoisted_200 = ["src"]
const _hoisted_201 = /*#__PURE__*/_createElementVNode("th", null, "欠測", -1)
const _hoisted_202 = { key: 6 }
const _hoisted_203 = { class: "legend-list__group-title legend-list__group-title_top" }
const _hoisted_204 = ["src"]
const _hoisted_205 = /*#__PURE__*/_createElementVNode("div", { class: "help-text" }, [
  /*#__PURE__*/_createTextVNode(" ・高速自動車道"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ・一般国道（NEXCO東日本・中日本・西日本/首都高・阪高・本四高速）"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ・一般都道府県道（NEXCO東日本・中日本・西日本） ")
], -1)
const _hoisted_206 = /*#__PURE__*/_createElementVNode("table", {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}, [
  /*#__PURE__*/_createElementVNode("tbody", null, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level1" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "80(km/h)以上")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level2" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "60～79(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level3" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "50～59(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level4" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "40～49(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level5" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "20～39(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level6" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "0～19(km/h)")
    ])
  ])
], -1)
const _hoisted_207 = { class: "legend-list__group-title legend-list__group-title_top" }
const _hoisted_208 = ["src"]
const _hoisted_209 = /*#__PURE__*/_createElementVNode("div", { class: "help-text" }, [
  /*#__PURE__*/_createTextVNode(" ・都市高速道路"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ・一般国道（道路公社）"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ・主要地方道（都道府県道）（道路公社）"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ・一般都道府県道（道路公社）"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ・指定市の一般市道（首都高・阪高・本四高速/道路公社） ")
], -1)
const _hoisted_210 = /*#__PURE__*/_createElementVNode("table", {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}, [
  /*#__PURE__*/_createElementVNode("tbody", null, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level1" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "60(km/h)以上")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level2" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "40～59(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level3" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "30～39(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level4" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "20～29(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level5" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "10～19(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level6" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "0～9(km/h)")
    ])
  ])
], -1)
const _hoisted_211 = { class: "legend-list__group-title legend-list__group-title_top" }
const _hoisted_212 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_213 = ["src"]
const _hoisted_214 = /*#__PURE__*/_createElementVNode("div", { class: "help-text" }, [
  /*#__PURE__*/_createTextVNode(" ・一般国道（その他の管理者コード）"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ・主要地方道（都道府県道）（その他の管理者コード）"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ・主要地方道（指定市市道）"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ・一般都道府県道（その他の管理者コード）"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ・指定市の一般市道（その他の管理者コード）"),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_215 = /*#__PURE__*/_createElementVNode("table", {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}, [
  /*#__PURE__*/_createElementVNode("tbody", null, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level1" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "40(km/h)以上")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level2" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "20～39(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level3" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "15～19(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level4" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "10～14(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level5" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "5～9(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level6" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "0～4(km/h)")
    ])
  ])
], -1)
const _hoisted_216 = { key: 7 }
const _hoisted_217 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・都市間高速道路 ", -1)
const _hoisted_218 = /*#__PURE__*/_createElementVNode("table", {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}, [
  /*#__PURE__*/_createElementVNode("tbody", null, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level1" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "80(km/h)以上")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level2" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "60～79(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level3" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "50～59(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level4" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "40～49(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level5" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "20～39(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level6" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "0～19(km/h)")
    ])
  ])
], -1)
const _hoisted_219 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・都市内高速道路 ", -1)
const _hoisted_220 = /*#__PURE__*/_createElementVNode("table", {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}, [
  /*#__PURE__*/_createElementVNode("tbody", null, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level1" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "60(km/h)以上")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level2" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "40～59(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level3" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "30～39(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level4" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "20～29(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level5" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "10～19(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level6" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "0～9(km/h)")
    ])
  ])
], -1)
const _hoisted_221 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・一般道 ", -1)
const _hoisted_222 = /*#__PURE__*/_createElementVNode("table", {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}, [
  /*#__PURE__*/_createElementVNode("tbody", null, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level1" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "40(km/h)以上")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level2" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "20～39(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level3" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "15～19(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level4" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "10～14(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level5" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "5～9(km/h)")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_level6" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "0～4(km/h)")
    ])
  ])
], -1)
const _hoisted_223 = [
  _hoisted_217,
  _hoisted_218,
  _hoisted_219,
  _hoisted_220,
  _hoisted_221,
  _hoisted_222
]
const _hoisted_224 = { key: 8 }
const _hoisted_225 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・色 ", -1)
const _hoisted_226 = {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}
const _hoisted_227 = ["src"]
const _hoisted_228 = /*#__PURE__*/_createElementVNode("th", null, "出発点", -1)
const _hoisted_229 = ["src"]
const _hoisted_230 = /*#__PURE__*/_createElementVNode("th", null, "到着点", -1)
const _hoisted_231 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・円の大きさ ", -1)
const _hoisted_232 = /*#__PURE__*/_createElementVNode("table", {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}, [
  /*#__PURE__*/_createElementVNode("tbody", null, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "10px"),
      /*#__PURE__*/_createElementVNode("th", null, "10％以下")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "20px"),
      /*#__PURE__*/_createElementVNode("th", null, "11～20％")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "30px"),
      /*#__PURE__*/_createElementVNode("th", null, "21～30％")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "40px"),
      /*#__PURE__*/_createElementVNode("th", null, "31～40％")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "50px"),
      /*#__PURE__*/_createElementVNode("th", null, "41～50％")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "60px"),
      /*#__PURE__*/_createElementVNode("th", null, "51～60％")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "70px"),
      /*#__PURE__*/_createElementVNode("th", null, "61～70％")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "80px"),
      /*#__PURE__*/_createElementVNode("th", null, "71～80％")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "90px"),
      /*#__PURE__*/_createElementVNode("th", null, "81～90％")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "100px"),
      /*#__PURE__*/_createElementVNode("th", null, "91％以上")
    ])
  ])
], -1)
const _hoisted_233 = { key: 9 }
const _hoisted_234 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・色 ", -1)
const _hoisted_235 = {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}
const _hoisted_236 = ["src"]
const _hoisted_237 = /*#__PURE__*/_createElementVNode("th", null, "発生・集中量", -1)
const _hoisted_238 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・円の大きさ ", -1)
const _hoisted_239 = /*#__PURE__*/_createElementVNode("table", {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}, [
  /*#__PURE__*/_createElementVNode("tbody", null, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "10px"),
      /*#__PURE__*/_createElementVNode("th", null, "199,999以下")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "20px"),
      /*#__PURE__*/_createElementVNode("th", null, "200,000～399,999")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "30px"),
      /*#__PURE__*/_createElementVNode("th", null, "400,000～599,999")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "40px"),
      /*#__PURE__*/_createElementVNode("th", null, "600,000～799,999")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "50px"),
      /*#__PURE__*/_createElementVNode("th", null, "800,000～999,999")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "60px"),
      /*#__PURE__*/_createElementVNode("th", null, "1,000,000～1,199,999")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "70px"),
      /*#__PURE__*/_createElementVNode("th", null, "1,200,000～1,399,999")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "80px"),
      /*#__PURE__*/_createElementVNode("th", null, "1,400,000～1,599,999")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "90px"),
      /*#__PURE__*/_createElementVNode("th", null, "1,600,000～1,799,999")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, "100px"),
      /*#__PURE__*/_createElementVNode("th", null, "1,800,000以上")
    ])
  ])
], -1)
const _hoisted_240 = { key: 10 }
const _hoisted_241 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・点検DB ", -1)
const _hoisted_242 = {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}
const _hoisted_243 = ["src"]
const _hoisted_244 = /*#__PURE__*/_createElementVNode("th", null, "道路橋", -1)
const _hoisted_245 = ["src"]
const _hoisted_246 = /*#__PURE__*/_createElementVNode("th", null, "トンネル", -1)
const _hoisted_247 = ["src"]
const _hoisted_248 = /*#__PURE__*/_createElementVNode("th", null, "シェッド", -1)
const _hoisted_249 = ["src"]
const _hoisted_250 = /*#__PURE__*/_createElementVNode("th", null, "大型カルバート", -1)
const _hoisted_251 = ["src"]
const _hoisted_252 = /*#__PURE__*/_createElementVNode("th", null, "横断歩道橋", -1)
const _hoisted_253 = ["src"]
const _hoisted_254 = /*#__PURE__*/_createElementVNode("th", null, "門型標識等", -1)
const _hoisted_255 = ["src"]
const _hoisted_256 = /*#__PURE__*/_createElementVNode("th", null, "舗装", -1)
const _hoisted_257 = { key: 11 }
const _hoisted_258 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・道路属性データ ", -1)
const _hoisted_259 = {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}
const _hoisted_260 = ["src"]
const _hoisted_261 = /*#__PURE__*/_createElementVNode("th", null, "全国重要物流道路", -1)
const _hoisted_262 = ["src"]
const _hoisted_263 = /*#__PURE__*/_createElementVNode("th", null, "全国代替補完路", -1)
const _hoisted_264 = { key: 12 }
const _hoisted_265 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・リンク ", -1)
const _hoisted_266 = /*#__PURE__*/_createElementVNode("table", {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}, [
  /*#__PURE__*/_createElementVNode("tbody", null, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_green" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "高速道路")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_green" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "高速道路（国道有料区間）")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_light_green" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "高速道路（国道無料区間）")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_green" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "都市高速道路")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_light_red" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "一般国道（指定区間該当）")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_light_red" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "一般国道")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_yellow" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "主要地方道[都道府県道]")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_light_orange" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "主要地方道[指定市道]")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_yellow" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "一般都道府県道")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_white" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "指定市の一般市道")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_white" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "基本道路：その他道路")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_white" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "基本道路：未調査")
    ])
  ])
], -1)
const _hoisted_267 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・ノード ", -1)
const _hoisted_268 = {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}
const _hoisted_269 = ["src"]
const _hoisted_270 = /*#__PURE__*/_createElementVNode("th", null, "ノード", -1)
const _hoisted_271 = { key: 13 }
const _hoisted_272 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・リンク ", -1)
const _hoisted_273 = /*#__PURE__*/_createElementVNode("table", {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}, [
  /*#__PURE__*/_createElementVNode("tbody", null, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_green" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "高速道路")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_green" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "高速道路（国道有料区間）")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_light_green" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "高速道路（国道無料区間）")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_green" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "都市高速道路")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_light_red" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "一般国道（指定区間該当）")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_light_red" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "一般国道")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_yellow" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "主要地方道[都道府県道]")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_light_orange" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "主要地方道[指定市道]")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_yellow" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "一般都道府県道")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_white" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "指定市の一般市道")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_white" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "基本道路：その他道路")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_white" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "基本道路：未調査")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_white" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "細道路：その他道路")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "legend-list__line_white" })
      ]),
      /*#__PURE__*/_createElementVNode("th", null, "細道路：未調査")
    ])
  ])
], -1)
const _hoisted_274 = /*#__PURE__*/_createElementVNode("div", { class: "legend-list__group-title legend-list__group-title_top" }, " ・ノード ", -1)
const _hoisted_275 = {
  class: "legend-list__group-table",
  border: "10",
  frame: "box",
  rules: "none"
}
const _hoisted_276 = ["src"]
const _hoisted_277 = /*#__PURE__*/_createElementVNode("th", null, "ノード", -1)

import { SelectItem, Tooltip } from "@/components/modules";
import { ref } from "vue";
import level1LayerIcon from "@/../public/icon/layer/point_level1.png";
import level2LayerIcon from "@/../public/icon/layer/point_level2.png";
import level3LayerIcon from "@/../public/icon/layer/point_level3.png";
import level4LayerIcon from "@/../public/icon/layer/point_level4.png";
import level5LayerIcon from "@/../public/icon/layer/point_level5.png";
import level6LayerIcon from "@/../public/icon/layer/point_level6.png";
import odPointDepartureLayerIcon from "@/../public/icon/layer/od_point_departure.png";
import odPointArrivalLayerIcon from "@/../public/icon/layer/od_point_arrival.png";
import odPointGenerationLayerIcon from "@/../public/icon/layer/od_point_generation.png";
import missingLayerIcon from "@/../public/icon/layer/point_missing.png";
import BridgesLayerIcon from "@/../public/icon/layer/structures-bridges.png";
import TunnelsLayerIcon from "@/../public/icon/layer/structures-tunnels.png";
import ShedsLayerIcon from "@/../public/icon/layer/structures-sheds.png";
import CulvertsLayerIcon from "@/../public/icon/layer/structures-culverts.png";
import PedestrianDecksLayerIcon from "@/../public/icon/layer/structures-pedestrian_decks.png";
import OverheadSignagesLayerIcon from "@/../public/icon/layer/structures-overhead_signages.png";
import PavementsLayerIcon from "@/../public/icon/layer/structures-pavements.png";
import RoadtypeLogisticsLayerIcon from "@/../public/icon/layer/roadtype-logistics.png";
import RoadtypeAlternativeLayerIcon from "@/../public/icon/layer/roadtype-alternative.png";
import QuestionIcon from "@/../public/icon/dialog/info.png";

/**
 * 交通量データサブリスト
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'legend-list',
  setup(__props) {

const SUB_LIST_TRAVOS = [
  {
    key: "travos_history_q82",
    text: "過去-計測１時間(Q-8-2)",
  },
  {
    key: "travos_history_qa82",
    text: "過去-計測１時間(QA-8-2)",
  },
  {
    key: "travos_realtime_q81",
    text: "最新-計測５分(Q-8-1)",
  },
  {
    key: "travos_realtime_qa81",
    text: "最新-計測５分(QA-8-1)",
  },
  {
    key: "travos_realtime_q82",
    text: "最新-計測１時間(Q-8-2)",
  },
  {
    key: "travos_realtime_qa82",
    text: "最新-計測１時間(QA-8-2)",
  },
];

/**
 * ETC2.0サブリスト
 */
const SUB_LIST_ETC = [
  {
    key: "etc_drm",
    text: "DRMリンク",
  },
  {
    key: "etc_traffic",
    text: "交通調査基本区間",
  },
];

/**
 * ODサブリスト
 */
const SUB_LIST_OD = [
  { key: "od_traffic_pref", text: "OD交通量-都道府県" },
  { key: "od_generation_pref", text: "発生・集中量-都道府県" },
];

/**
 * 点検DBサブリスト
 */
const SUB_LIST_ROAD_STRUCTURES = [{ key: "road_structures", text: "点検DB" }];

/**
 * 道路属性データサブリスト
 */
const SUB_LIST_ROAD_TYPE = [{ key: "road_type", text: "道路属性データ" }];

/**
 * DRM-DBサブリスト
 */
const SUB_LIST_DRM = [
  { key: "drm_basic_road", text: "基本道路" },
  { key: "drm_all_road", text: "全道路" },
];

/**
 * サイドメニューリスト
 */
const MAIN_LIST = {
  travos: { text: "交通量データ", subList: SUB_LIST_TRAVOS },
  etc: { text: "ETC2.0", subList: SUB_LIST_ETC },
  od: { text: "OD", subList: SUB_LIST_OD },
  roadStructures: { text: "点検DB", subList: SUB_LIST_ROAD_STRUCTURES },
  roadType: { text: "道路属性データ", subList: SUB_LIST_ROAD_TYPE },
  drm: { text: "DRM-DB", subList: SUB_LIST_DRM },
};

/**
 * 選択中サブ項目
 */
const selectedSubListItem = ref(SUB_LIST_TRAVOS[0].key);

/**
 * サブリスト
 */
const subList = ref(SUB_LIST_TRAVOS);

/**
 * メイン項目選択変更
 */
const changeMain = (index: number) => {
  subList.value = Object.values(MAIN_LIST)[index].subList;
  setTimeout(() => {
    selectedSubListItem.value = subList.value[0].key;
    setTimeout(() => {
      if (index == 1) {
        const legendList = document.getElementById("legend-list");
        const toolTips = document.querySelectorAll(".help-tooltip");
        legendList.addEventListener("scroll", () => {
          const scrollY = legendList.scrollTop;
          toolTips.forEach((ele: any) => {
            ele.style.transform = "translateY(-" + scrollY + "px)";
          });
        });
      }
    }, 10);
  }, 10);
};

/**
 * サブ項目選択変更
 */
const changeSub = (item: string) => {
  selectedSubListItem.value = item;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(SelectItem), {
      fontSize: "1.6rem",
      height: "28px",
      onUpdate: _cache[0] || (_cache[0] = 
        (index) => {
          changeMain(index);
        }
      )
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(MAIN_LIST), (ele, index) => {
          return (_openBlock(), _createElementBlock("option", {
            value: index,
            key: Object.keys(MAIN_LIST)[index]
          }, _toDisplayString(ele.text), 9, _hoisted_2))
        }), 128))
      ]),
      _: 1
    }),
    _withDirectives(_createVNode(_unref(SelectItem), {
      class: "legend-list__sub-item",
      fontSize: "1.6rem",
      height: "28px",
      value: selectedSubListItem.value,
      onUpdate: _cache[1] || (_cache[1] = (item)=>{changeSub(item);})
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subList.value, (ele) => {
          return (_openBlock(), _createElementBlock("option", {
            value: ele.key,
            key: ele.key
          }, _toDisplayString(ele.text), 9, _hoisted_3))
        }), 128))
      ]),
      _: 1
    }, 8, ["value"]), [
      [_vShow, subList.value.length >= 2]
    ]),
    (selectedSubListItem.value == SUB_LIST_TRAVOS[0].key)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("table", _hoisted_6, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level1LayerIcon) }, null, 8, _hoisted_7)
                ]),
                _hoisted_8
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level2LayerIcon) }, null, 8, _hoisted_9)
                ]),
                _hoisted_10
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level3LayerIcon) }, null, 8, _hoisted_11)
                ]),
                _hoisted_12
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level4LayerIcon) }, null, 8, _hoisted_13)
                ]),
                _hoisted_14
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level5LayerIcon) }, null, 8, _hoisted_15)
                ]),
                _hoisted_16
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level6LayerIcon) }, null, 8, _hoisted_17)
                ]),
                _hoisted_18
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(missingLayerIcon) }, null, 8, _hoisted_19)
                ]),
                _hoisted_20
              ])
            ])
          ]),
          _hoisted_21,
          _createElementVNode("table", _hoisted_22, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level1LayerIcon) }, null, 8, _hoisted_23)
                ]),
                _hoisted_24
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level2LayerIcon) }, null, 8, _hoisted_25)
                ]),
                _hoisted_26
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level3LayerIcon) }, null, 8, _hoisted_27)
                ]),
                _hoisted_28
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level4LayerIcon) }, null, 8, _hoisted_29)
                ]),
                _hoisted_30
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level5LayerIcon) }, null, 8, _hoisted_31)
                ]),
                _hoisted_32
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level6LayerIcon) }, null, 8, _hoisted_33)
                ]),
                _hoisted_34
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(missingLayerIcon) }, null, 8, _hoisted_35)
                ]),
                _hoisted_36
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (selectedSubListItem.value == SUB_LIST_TRAVOS[1].key)
      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
          _hoisted_38,
          _createElementVNode("table", _hoisted_39, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level1LayerIcon) }, null, 8, _hoisted_40)
                ]),
                _hoisted_41
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level2LayerIcon) }, null, 8, _hoisted_42)
                ]),
                _hoisted_43
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level3LayerIcon) }, null, 8, _hoisted_44)
                ]),
                _hoisted_45
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level4LayerIcon) }, null, 8, _hoisted_46)
                ]),
                _hoisted_47
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level5LayerIcon) }, null, 8, _hoisted_48)
                ]),
                _hoisted_49
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level6LayerIcon) }, null, 8, _hoisted_50)
                ]),
                _hoisted_51
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(missingLayerIcon) }, null, 8, _hoisted_52)
                ]),
                _hoisted_53
              ])
            ])
          ]),
          _hoisted_54,
          _createElementVNode("table", _hoisted_55, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level1LayerIcon) }, null, 8, _hoisted_56)
                ]),
                _hoisted_57
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level2LayerIcon) }, null, 8, _hoisted_58)
                ]),
                _hoisted_59
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level3LayerIcon) }, null, 8, _hoisted_60)
                ]),
                _hoisted_61
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level4LayerIcon) }, null, 8, _hoisted_62)
                ]),
                _hoisted_63
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level5LayerIcon) }, null, 8, _hoisted_64)
                ]),
                _hoisted_65
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level6LayerIcon) }, null, 8, _hoisted_66)
                ]),
                _hoisted_67
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(missingLayerIcon) }, null, 8, _hoisted_68)
                ]),
                _hoisted_69
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (selectedSubListItem.value == SUB_LIST_TRAVOS[2].key)
      ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
          _hoisted_71,
          _createElementVNode("table", _hoisted_72, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level1LayerIcon) }, null, 8, _hoisted_73)
                ]),
                _hoisted_74
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level2LayerIcon) }, null, 8, _hoisted_75)
                ]),
                _hoisted_76
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level3LayerIcon) }, null, 8, _hoisted_77)
                ]),
                _hoisted_78
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level4LayerIcon) }, null, 8, _hoisted_79)
                ]),
                _hoisted_80
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level5LayerIcon) }, null, 8, _hoisted_81)
                ]),
                _hoisted_82
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level6LayerIcon) }, null, 8, _hoisted_83)
                ]),
                _hoisted_84
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(missingLayerIcon) }, null, 8, _hoisted_85)
                ]),
                _hoisted_86
              ])
            ])
          ]),
          _hoisted_87,
          _createElementVNode("table", _hoisted_88, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level1LayerIcon) }, null, 8, _hoisted_89)
                ]),
                _hoisted_90
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level2LayerIcon) }, null, 8, _hoisted_91)
                ]),
                _hoisted_92
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level3LayerIcon) }, null, 8, _hoisted_93)
                ]),
                _hoisted_94
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level4LayerIcon) }, null, 8, _hoisted_95)
                ]),
                _hoisted_96
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level5LayerIcon) }, null, 8, _hoisted_97)
                ]),
                _hoisted_98
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level6LayerIcon) }, null, 8, _hoisted_99)
                ]),
                _hoisted_100
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(missingLayerIcon) }, null, 8, _hoisted_101)
                ]),
                _hoisted_102
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (selectedSubListItem.value == SUB_LIST_TRAVOS[3].key)
      ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
          _hoisted_104,
          _createElementVNode("table", _hoisted_105, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level1LayerIcon) }, null, 8, _hoisted_106)
                ]),
                _hoisted_107
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level2LayerIcon) }, null, 8, _hoisted_108)
                ]),
                _hoisted_109
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level3LayerIcon) }, null, 8, _hoisted_110)
                ]),
                _hoisted_111
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level4LayerIcon) }, null, 8, _hoisted_112)
                ]),
                _hoisted_113
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level5LayerIcon) }, null, 8, _hoisted_114)
                ]),
                _hoisted_115
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level6LayerIcon) }, null, 8, _hoisted_116)
                ]),
                _hoisted_117
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(missingLayerIcon) }, null, 8, _hoisted_118)
                ]),
                _hoisted_119
              ])
            ])
          ]),
          _hoisted_120,
          _createElementVNode("table", _hoisted_121, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level1LayerIcon) }, null, 8, _hoisted_122)
                ]),
                _hoisted_123
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level2LayerIcon) }, null, 8, _hoisted_124)
                ]),
                _hoisted_125
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level3LayerIcon) }, null, 8, _hoisted_126)
                ]),
                _hoisted_127
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level4LayerIcon) }, null, 8, _hoisted_128)
                ]),
                _hoisted_129
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level5LayerIcon) }, null, 8, _hoisted_130)
                ]),
                _hoisted_131
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level6LayerIcon) }, null, 8, _hoisted_132)
                ]),
                _hoisted_133
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(missingLayerIcon) }, null, 8, _hoisted_134)
                ]),
                _hoisted_135
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (selectedSubListItem.value == SUB_LIST_TRAVOS[4].key)
      ? (_openBlock(), _createElementBlock("div", _hoisted_136, [
          _hoisted_137,
          _createElementVNode("table", _hoisted_138, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level1LayerIcon) }, null, 8, _hoisted_139)
                ]),
                _hoisted_140
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level2LayerIcon) }, null, 8, _hoisted_141)
                ]),
                _hoisted_142
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level3LayerIcon) }, null, 8, _hoisted_143)
                ]),
                _hoisted_144
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level4LayerIcon) }, null, 8, _hoisted_145)
                ]),
                _hoisted_146
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level5LayerIcon) }, null, 8, _hoisted_147)
                ]),
                _hoisted_148
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level6LayerIcon) }, null, 8, _hoisted_149)
                ]),
                _hoisted_150
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(missingLayerIcon) }, null, 8, _hoisted_151)
                ]),
                _hoisted_152
              ])
            ])
          ]),
          _hoisted_153,
          _createElementVNode("table", _hoisted_154, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level1LayerIcon) }, null, 8, _hoisted_155)
                ]),
                _hoisted_156
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level2LayerIcon) }, null, 8, _hoisted_157)
                ]),
                _hoisted_158
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level3LayerIcon) }, null, 8, _hoisted_159)
                ]),
                _hoisted_160
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level4LayerIcon) }, null, 8, _hoisted_161)
                ]),
                _hoisted_162
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level5LayerIcon) }, null, 8, _hoisted_163)
                ]),
                _hoisted_164
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level6LayerIcon) }, null, 8, _hoisted_165)
                ]),
                _hoisted_166
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(missingLayerIcon) }, null, 8, _hoisted_167)
                ]),
                _hoisted_168
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (selectedSubListItem.value == SUB_LIST_TRAVOS[5].key)
      ? (_openBlock(), _createElementBlock("div", _hoisted_169, [
          _hoisted_170,
          _createElementVNode("table", _hoisted_171, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level1LayerIcon) }, null, 8, _hoisted_172)
                ]),
                _hoisted_173
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level2LayerIcon) }, null, 8, _hoisted_174)
                ]),
                _hoisted_175
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level3LayerIcon) }, null, 8, _hoisted_176)
                ]),
                _hoisted_177
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level4LayerIcon) }, null, 8, _hoisted_178)
                ]),
                _hoisted_179
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level5LayerIcon) }, null, 8, _hoisted_180)
                ]),
                _hoisted_181
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level6LayerIcon) }, null, 8, _hoisted_182)
                ]),
                _hoisted_183
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(missingLayerIcon) }, null, 8, _hoisted_184)
                ]),
                _hoisted_185
              ])
            ])
          ]),
          _hoisted_186,
          _createElementVNode("table", _hoisted_187, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level1LayerIcon) }, null, 8, _hoisted_188)
                ]),
                _hoisted_189
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level2LayerIcon) }, null, 8, _hoisted_190)
                ]),
                _hoisted_191
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level3LayerIcon) }, null, 8, _hoisted_192)
                ]),
                _hoisted_193
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level4LayerIcon) }, null, 8, _hoisted_194)
                ]),
                _hoisted_195
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level5LayerIcon) }, null, 8, _hoisted_196)
                ]),
                _hoisted_197
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(level6LayerIcon) }, null, 8, _hoisted_198)
                ]),
                _hoisted_199
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(missingLayerIcon) }, null, 8, _hoisted_200)
                ]),
                _hoisted_201
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (selectedSubListItem.value == SUB_LIST_ETC[0].key)
      ? (_openBlock(), _createElementBlock("div", _hoisted_202, [
          _createElementVNode("div", _hoisted_203, [
            _createTextVNode(" ・高速道路 "),
            _createVNode(_unref(Tooltip), {
              direction: "text",
              class: "help-tooltip",
              tooltipId: "etcExpressway",
              id: "tooltipImage-etcExpressway"
            }, {
              label: _withCtx(() => [
                _createElementVNode("img", {
                  src: _unref(QuestionIcon),
                  class: "help-icon"
                }, null, 8, _hoisted_204)
              ]),
              content: _withCtx(() => [
                _hoisted_205
              ]),
              _: 1
            })
          ]),
          _hoisted_206,
          _createElementVNode("div", _hoisted_207, [
            _createTextVNode(" ・都市高速道路 "),
            _createVNode(_unref(Tooltip), {
              direction: "text",
              class: "help-tooltip",
              tooltipId: "etcCityExpressway",
              id: "tooltipImage-etcCityExpressway"
            }, {
              label: _withCtx(() => [
                _createElementVNode("img", {
                  src: _unref(QuestionIcon),
                  class: "help-icon"
                }, null, 8, _hoisted_208)
              ]),
              content: _withCtx(() => [
                _hoisted_209
              ]),
              _: 1
            })
          ]),
          _hoisted_210,
          _createElementVNode("div", _hoisted_211, [
            _createTextVNode(" ・一般道路 "),
            _hoisted_212,
            _createTextVNode("（一般国道、都道府県など） "),
            _createVNode(_unref(Tooltip), {
              direction: "text",
              class: "help-tooltip",
              tooltipId: "etcWay",
              id: "tooltipImage-etcWay"
            }, {
              label: _withCtx(() => [
                _createElementVNode("img", {
                  src: _unref(QuestionIcon),
                  class: "help-icon"
                }, null, 8, _hoisted_213)
              ]),
              content: _withCtx(() => [
                _hoisted_214
              ]),
              _: 1
            })
          ]),
          _hoisted_215
        ]))
      : _createCommentVNode("", true),
    (selectedSubListItem.value == SUB_LIST_ETC[1].key)
      ? (_openBlock(), _createElementBlock("div", _hoisted_216, _hoisted_223))
      : _createCommentVNode("", true),
    (selectedSubListItem.value == SUB_LIST_OD[0].key)
      ? (_openBlock(), _createElementBlock("div", _hoisted_224, [
          _hoisted_225,
          _createElementVNode("table", _hoisted_226, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(odPointDepartureLayerIcon) }, null, 8, _hoisted_227)
                ]),
                _hoisted_228
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(odPointArrivalLayerIcon) }, null, 8, _hoisted_229)
                ]),
                _hoisted_230
              ])
            ])
          ]),
          _hoisted_231,
          _hoisted_232
        ]))
      : _createCommentVNode("", true),
    (selectedSubListItem.value == SUB_LIST_OD[1].key)
      ? (_openBlock(), _createElementBlock("div", _hoisted_233, [
          _hoisted_234,
          _createElementVNode("table", _hoisted_235, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(odPointGenerationLayerIcon) }, null, 8, _hoisted_236)
                ]),
                _hoisted_237
              ])
            ])
          ]),
          _hoisted_238,
          _hoisted_239
        ]))
      : _createCommentVNode("", true),
    (selectedSubListItem.value == SUB_LIST_ROAD_STRUCTURES[0].key)
      ? (_openBlock(), _createElementBlock("div", _hoisted_240, [
          _hoisted_241,
          _createElementVNode("table", _hoisted_242, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(BridgesLayerIcon) }, null, 8, _hoisted_243)
                ]),
                _hoisted_244
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(TunnelsLayerIcon) }, null, 8, _hoisted_245)
                ]),
                _hoisted_246
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(ShedsLayerIcon) }, null, 8, _hoisted_247)
                ]),
                _hoisted_248
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(CulvertsLayerIcon) }, null, 8, _hoisted_249)
                ]),
                _hoisted_250
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(PedestrianDecksLayerIcon) }, null, 8, _hoisted_251)
                ]),
                _hoisted_252
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(OverheadSignagesLayerIcon) }, null, 8, _hoisted_253)
                ]),
                _hoisted_254
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(PavementsLayerIcon) }, null, 8, _hoisted_255)
                ]),
                _hoisted_256
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (selectedSubListItem.value == SUB_LIST_ROAD_TYPE[0].key)
      ? (_openBlock(), _createElementBlock("div", _hoisted_257, [
          _hoisted_258,
          _createElementVNode("table", _hoisted_259, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(RoadtypeLogisticsLayerIcon) }, null, 8, _hoisted_260)
                ]),
                _hoisted_261
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(RoadtypeAlternativeLayerIcon) }, null, 8, _hoisted_262)
                ]),
                _hoisted_263
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (selectedSubListItem.value == SUB_LIST_DRM[0].key)
      ? (_openBlock(), _createElementBlock("div", _hoisted_264, [
          _hoisted_265,
          _hoisted_266,
          _hoisted_267,
          _createElementVNode("table", _hoisted_268, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(missingLayerIcon) }, null, 8, _hoisted_269)
                ]),
                _hoisted_270
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (selectedSubListItem.value == SUB_LIST_DRM[1].key)
      ? (_openBlock(), _createElementBlock("div", _hoisted_271, [
          _hoisted_272,
          _hoisted_273,
          _hoisted_274,
          _createElementVNode("table", _hoisted_275, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", { src: _unref(missingLayerIcon) }, null, 8, _hoisted_276)
                ]),
                _hoisted_277
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})